import React from 'react'

import { Box, List, makeStyles } from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'

import { CustomListItemText, ListItemButton } from '~/customer/components/CustomerSidebar'

const useStyles = makeStyles((theme) => ({
  listItem: {
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(10),
  },
  listTriangleGapCompensor: {
    width: '100%',
  },
}))

interface ListItemProps {
  accountNumber: string
  onChangeSelected: (itemId: string) => void
  itemId: string
  selectedItemsIds: string[]
}

const OffersConfiguratorButton: React.FC<ListItemProps> = ({
  accountNumber,
  onChangeSelected,
  itemId,
  selectedItemsIds,
}) => {
  const classes = useStyles()

  return (
    <Box pt={4}>
      <List disablePadding className={classes.listTriangleGapCompensor}>
        <ListItemButton
          dataHook={`offers-configurator-button-${accountNumber}`}
          className={classes.listItem}
          selected={selectedItemsIds?.includes(itemId)}
          onClick={() => onChangeSelected(itemId)}
        >
          <Box pr={2}>
            <SettingsIcon />
          </Box>
          <CustomListItemText
            primary="Configurador"
            primaryTypographyProps={{ variant: 'subtitle2' }}
          />
        </ListItemButton>
      </List>
    </Box>
  )
}

export default OffersConfiguratorButton
